import { call, put } from 'redux-saga/effects';
import { refreshReceiptStatisticsSaga } from './refreshReceiptStatisticsSaga';
import { setTransactionsReviewed } from '../api';
import {
  setTransactionsReviewedSuccess,
  setTransactionsReviewedFailure,
  fetchAllExcelTransactionsRequest,
  fetchExcelFilesMetadataRequest,
} from '../actions';
import { SetTransactionsReviewedRequestAction } from '../types';
import { ApiError } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn } from 'store/app/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { buildTransactionsRefreshFilters } from 'utils/entityTransactionsRequestFilters';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* setTransactionsReviewedSaga(
  action: SetTransactionsReviewedRequestAction
) {
  try {
    const {
      organisationId,
      reviewIds,
      page,
      pageSize,
      filters,
      tabFileImportIds,
      suppressSuccessMessage,
    } = action.payload;

    if (!organisationId || !reviewIds?.length) {
      yield put(setTransactionsReviewedFailure());
      return;
    }

    const response = yield call(
      setTransactionsReviewed,
      organisationId,
      reviewIds
    );

    const err: ApiError | null = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(setTransactionsReviewedSuccess());
    // Refresh transactions so the UI reflects the updated reviewed status.
    // Strip file-panel filters so we do not keep the excelMetadataId subset from apply.
    const effectivePage = page ?? 1;
    const effectivePageSize = pageSize ?? 10;
    const refreshFilters = buildTransactionsRefreshFilters({
      tableFilters: filters,
      tabFileImportIds,
    });
    yield put(
      fetchAllExcelTransactionsRequest(
        organisationId,
        effectivePage,
        effectivePageSize,
        refreshFilters
      )
    );
    // Refresh file metadata so right-side file states/badges stay in sync.
    yield put(fetchExcelFilesMetadataRequest(organisationId));
    yield call(refreshReceiptStatisticsSaga);

    if (!suppressSuccessMessage) {
      const successMessage: MessageData = {
        title: i18n.t('common.success'),
        description: i18n.t('notifications.the-transactions-have-been-successfully-marked-as-reviewed'),
        type: MessageStates.SUCCESS,
      };
      yield put(turnMessageOn(successMessage));
    }
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(setTransactionsReviewedFailure());
  }
}
